import { render, staticRenderFns } from "./build_dashboard.vue?vue&type=template&id=f69c8206&scoped=true"
import script from "./build_dashboard.vue?vue&type=script&lang=js"
export * from "./build_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_dashboard.vue?vue&type=style&index=0&id=f69c8206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69c8206",
  null
  
)

export default component.exports